import { createRouter, createWebHistory } from 'vue-router';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: () => import('./pages/Dashboard.vue'), meta: { title: 'Dashboard' } },
    { path: '/usernames', component: () => import('./pages/Usernames.vue'), meta: { title: 'Usernames' } },
    { path: '/compose', component: () => import('./pages/Compose.vue'), meta: { title: 'Compose' } },
    { path: '/blacklist', component: () => import('./pages/Blacklist.vue'), meta: { title: 'Blacklist' } },
    { path: '/settings', component: () => import('./pages/Settings.vue'), meta: { title: 'Settings' } },
    { path: '/logs', component: () => import('./pages/Logs.vue'), meta: { title: 'Logs' } },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

router.afterEach((to) => {
  document.title = `${(to.meta.title as string | undefined) ?? 'Dashboard'} · Email Masking`;
});
